import type { LoaderFunctionArgs } from "@remix-run/node";
import { json, useLoaderData } from "@remix-run/react";
import { createApi } from "~/api/createApi.server";
import type { GetPrivacyPayload, GetSessionsRegionPayload } from "~/payloads";

export async function loader({ request }: LoaderFunctionArgs) {
  const api = await createApi(request);

  const sessionRegion = await api.getJson<GetSessionsRegionPayload>({
    endpoint: "/_/aa00/sessions/region",
  });

  const data = await api.getJson<GetPrivacyPayload>({
    endpoint: "/_/aa00/legals/venus_privacy",
    params: {
      ...(sessionRegion.result && {
        region: sessionRegion.result.langCode,
      }),
    },
  });

  return json({
    data,
  });
}

export default function Privacy() {
  const { data } = useLoaderData<typeof loader>();

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: data.result[0].description,
      }}
    />
  );
}
